import Map from '../map/RxGoogleMap';

const layerVisibilities = {
  'nitrogen-loss': true,
  'potential-productivity': true,
};

export default function GoogleMap() {
  return <Map pkRemovalEnabled layerVisibilities={layerVisibilities} />;
}
